import axios from 'axios'
import {
	Message
} from 'element-ui'
import store from '@/store/index'
import {
	baseUrl
} from "@/config/config";
import utils from "@/utils"

// create an axios instance
const service = axios.create({
	baseURL: baseUrl, // url = base url + request url
	// withCredentials: true, // send cookies when cross-domain requests
	timeout: 0 // request timeout
})

// request interceptor
service.interceptors.request.use(
	config => {
		// do something before request is sent
		if (!utils.getQueryVariable(config.url, 'noLoading')) {
			store.commit("app/addRequestNum", 1)
		}
		config.headers['pc'] = 1
		if (store.getters.token) {
			config.headers['token'] = store.getters.token
		}

		if (config.method === 'post') {
			if (Object.prototype.toString.call(config.data) !== "[object FormData]") {
				// config.data = qs.stringify(config.data);
				config.headers['Content-Type'] = 'application/json'
			}
		}
		return config
	},
	error => {
		// do something with request error
		// console.log(error) // for debug
		return Promise.reject(error)
	}
)

// response interceptor
service.interceptors.response.use(
	/**
	 * If you want to get http information such as headers or status
	 * Please return  response => response
	 */

	/**
	 * Determine the request status by custom errno
	 * Here is just an example
	 * You can also judge the status by HTTP Status errno
	 */
	async response => {
			if (!utils.getQueryVariable(response.config.url, 'noLoading')) {
				store.commit("app/addRequestNum", -1)
			}
			let res = response.data

			if (response.config.responseType === "blob") {
				if (response.headers["content-type"] === "application/json") {
					res = await utils.blob2String(res)
				} else {
					return Promise.resolve({
						headers: response.headers,
						data: response.data,
					})
				}
			}
			let [status, data] = execResult(res)
			if (!status) {
				return Promise.reject(data)
			} else {
				return Promise.resolve(data)
			}

	},
	error => {
		const response = error && error.response ? error.response : null
		const requestConfig = response && response.config ? response.config : (error.config || {})
		if (requestConfig.url && !utils.getQueryVariable(requestConfig.url, 'noLoading')) {
			store.commit("app/addRequestNum", -1)
		}
		if (response && response.status === 401) {
			store.dispatch("user/asyncLogout", response.headers.location).then(r => {})
		} else {

			let message = error.message
			if (response && response.status === 408) message = "抱歉，系统繁忙，请稍后重试！"
			if (response && response.status === 413) message = "单个文件大小超出上传限制！"
			if (!response) message = "无法连接到服务端，请检查后端是否启动或端口是否可访问"

			Message({
				message: message,
				type: 'error',
				duration: 5 * 1000
				})
				return Promise.reject(error)
			}
		}
)

const execResult = (res) => {
	if (Object.prototype.hasOwnProperty.call(res, "code")) {
		if (res.code === 200) {
			return [true, res.data]
		}
		Message({
			message: res.msg || 'Error',
			type: 'error',
			duration: 5 * 1000
		})
		return [false, res]
	}
	// if the custom errno is not 20000, it is judged as an error.
	if (res.errno == 100004) { // 10002
		store.dispatch("user/asyncLogout").then(r => {})
	} else if (res.errno == 3) {
		Message({
			message: res.errmsg,
			type: 'warning',
			duration: 5 * 1000
		})
		return [true, res.data]
	} else if (res.errno > 0) {
		let message = res.errmsg
		Message({
			message: message || 'Error',
			type: 'error',
			duration: 5 * 1000
		})
	} else {
		return [true, res.data]
	}
	store.commit("app/setLoading")
	return [false, res || "ERROR"]
}

export default service
